module.exports = __webpack_public_path__ + "img/air_pm25.77e075ee.svg";